"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultDatePeriod = exports.getDefaultDate = exports.shouldShowTabs = void 0;
var date_fns_1 = require("date-fns");
var core_1 = require("../../../../shared/core");
var includesASmartMeter = function (supplyInfo) {
    return [supplyInfo.electricity, supplyInfo.gas].some(function (supplyInfo) { return (supplyInfo === null || supplyInfo === void 0 ? void 0 : supplyInfo.type) === 'smart'; });
};
var shouldShowTabs = function (supplyInfo) {
    return includesASmartMeter(supplyInfo);
};
exports.shouldShowTabs = shouldShowTabs;
var getDefaultDate = function (search) {
    var result = (0, core_1.getValueFromQueryParams)('date', search);
    var resultDate = result && new Date(result);
    return resultDate && (0, date_fns_1.isValid)(resultDate) ? resultDate : (0, date_fns_1.startOfYesterday)();
};
exports.getDefaultDate = getDefaultDate;
var getDefaultDatePeriod = function (search, supplyInfo) {
    // Non smart users can only see 'yearly' so no need to check the query params.
    if (!includesASmartMeter(supplyInfo)) {
        return 'yearly';
    }
    var result = (0, core_1.getValueFromQueryParams)('datePeriod', search);
    return result === 'yearly' || result === 'monthly' || result === 'daily'
        ? result
        : 'monthly';
};
exports.getDefaultDatePeriod = getDefaultDatePeriod;
